import Api from '../utils/api.service';
import ApiUrlConstant from '../utils/apiUrl.constant';
import Util from '../utils/util';
export default class AccountService {
    static getGuestToken(countryCode) {
        const request = {
            type: 'guest',
            countryCode:countryCode
        }
        let url = ApiUrlConstant.getApiUrl('customerAuth', true);
        return Api.doPost(url, request);
    }
    static createAccount(request, headers) {
        let url = ApiUrlConstant.getApiUrl('customerSignUp', true);
        return Api.doPost(url, request, true, headers);
    }
    static fetchAccount(customerId, request, headers) {
        let url = ApiUrlConstant.getApiUrl('customerAccountDetails', true);
        url = Util.beautifyUrl(url, [customerId]);
        return Api.doGet(url);
    }
    

    static updateProfile(customerId, request) {
        let url = ApiUrlConstant.getApiUrl('customer', true);
        url = Util.beautifyUrl(url, [customerId]);
        return Api.doPost(url, request);
    }
    static login(request, headers) {
        let url = ApiUrlConstant.getApiUrl('customerAuth', true);
        return Api.doPost(url, request, true, headers);
    }
    static getWishlist(customerId, wishlistId, request, start = 0, count = Util.WISHLIST_PAGE_COUNT) {
        let url = ApiUrlConstant.getApiUrl('getWishlist', true);
        url = Util.beautifyUrl(url, [customerId, wishlistId, start, count]);
        return Api.doPost(url, request);
    }
    static syncWishlist(customerId, request) {
        let url = ApiUrlConstant.getApiUrl('wishlistSync', true);
        url = Util.beautifyUrl(url, [customerId]);
        return Api.doPost(url, request);
    }
    static removeFromWishlist(customerId, wishlistId, itemId, countryCode) {
        let url = ApiUrlConstant.getApiUrl('removeFromWishlist', true);
        const request = {
            countryCode:countryCode
        }
        url = Util.beautifyUrl(url, [customerId, wishlistId, itemId]);
        return Api.doPost(url, request);
    }
    static addProductToWishlist(customerId, request) {
        let url = ApiUrlConstant.getApiUrl('addToWishlist', true);
        url = Util.beautifyUrl(url, [customerId]);
        return Api.doPost(url, request);
    }
    static updatePassword(customerId, request) {
        let url = ApiUrlConstant.getApiUrl('updatePassword', true);
        url = Util.beautifyUrl(url, [customerId]);
        return Api.doPost(url, request);
    }
    static invalidateToken(countryCode) {
        const request = {
            countryCode:countryCode
        }
        let url = ApiUrlConstant.getApiUrl('logout', true);
        return Api.doPost(url, request);
    }
    static getPersonalizedPromos(request) {
        let url = ApiUrlConstant.getApiUrl('personalizedPromos', true);
        return Api.doPost(url, request);
    }
    static triggerWelcomeEmail(request) {
        let url = ApiUrlConstant.getApiUrl('triggerEmail', true);
        return Api.doPost(url, request);
    }
}